<template>
  <ScrollableList :isLoading="isLoading">
    <template #items>
      <Site
        v-for="site in sites"
        :key="site.id"
        :site="site"
        :showChevron="showChevron || isSiteChevronShown(site.id)"
        :showCheckbox="showCheckbox || isSiteChecked(site.id)"
        :isChecked="isSiteChecked(site.id)"
        :isIndeterminate="isSiteIndeterminate(site.id)"
        :isActive="isSiteActive(site.id)"
        @click="$emit('selected', $event)"
        @check="$emit('checked', $event)"
      />
    </template>
    <template #skeleton>
      <SiteSkeleton />
    </template>
  </ScrollableList>
</template>

<script setup>
import { ScrollableList } from "@/Components/List";
import { Site, SiteSkeleton } from "@/Components/Site";

defineEmits(["selected", "checked"]);

const props = defineProps({
  sites: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  showChevron: {
    type: Boolean,
    default: false,
  },
  showCheckbox: {
    type: Boolean,
    default: false,
  },
  chevronSites: {
    type: Array,
    default: () => [],
  },
  checkedSites: {
    type: Array,
    default: () => [],
  },
  indeterminateSites: {
    type: Array,
    default: () => [],
  },
  activeSiteIds: {
    type: Array,
    default: () => [],
  },
});

function isSiteChecked(siteId) {
  return props.checkedSites.includes(siteId);
}

function isSiteIndeterminate(siteId) {
  return props.indeterminateSites.includes(siteId);
}

function isSiteChevronShown(siteId) {
  return props.chevronSites.includes(siteId);
}

function isSiteActive(siteId) {
  return props.activeSiteIds.includes(siteId);
}
</script>
